module.exports = "/static/media/popUpCartoon.b1844637.svg";